import {canInsertTopLevelBlockSelectable} from "./topLevel.js";
import {changeByRangeTrimmedBlockCursor} from "./changes.js";

export function insertCodeBlockChangeSet(changeSet) {
  return ({state, dispatch}) => {
    if (canInsertTopLevelBlockSelectable({state})) {
      dispatch(changeByRangeTrimmedBlockCursor(state, text => changeSet(codeMark(text), text)));
    }
  };
}

function codeMark(text) {
  for (let number = 3; ; ++number) {
    if (!hasTicks(text, number)) {
      return ticks(number);
    }
    if (!hasFences(text, number)) {
      return fences(number);
    }
  }
}

function ticks(number) {
  return '`'.repeat(number);
}

function fences(number) {
  return '~'.repeat(number);
}

function hasTicks(text, number) {
  return text.indexOf(ticks(number)) > -1;
}

function hasFences(text, number) {
  return text.indexOf(fences(number)) > -1;
}
